import { useEffect, useState } from 'react';

/**
 * ¿Ventana angosta (< 768 px)? El login no puede resolverlo solo con CSS porque
 * algunos tamaños son numéricos (el fontSize del titular con glitch) y se
 * necesita el valor antes del render.
 */
export function useEsMovil(): boolean {
  const [esMovil, setEsMovil] = useState(
    typeof window !== 'undefined' ? window.innerWidth < 768 : false,
  );
  useEffect(() => {
    const onResize = () => setEsMovil(window.innerWidth < 768);
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, []);
  return esMovil;
}
